import Dashboard from '../views/Dashboard'
import Projects from '../views/Projects'
import Reports from '../views/Reports'
import Team from '../views/Team'
import { SettingsIcon, SvgIconProps } from '../components/Svgs'
import Settings from '../views/Settings'
import { UserRoleNames } from '../models/AccessControl'
import AdminSettings from '../views/AdminSettings'
import PersonalSettings from '../views/PersonalSettings'
import GeneralSettings from '../views/GeneralSettings'
import Members from '../views/Members'
import PlansAndBillings from '../views/Plans&Billings'

export interface ToolItemProps {
  label: string
  route?: string
  component: () => JSX.Element
  icon?: React.FC<SvgIconProps>
  nestedRoutes?: ToolItemProps[]
  roles?: UserRoleNames[]
}

export const commonToolItems: ToolItemProps[] = [
  {
    label: 'Marketplace',
    component: Dashboard,
    route: '/',
  },
  {
    label: 'Rendering',
    component: Projects,
    route: '/',
  },
  {
    label: 'Plugins',
    component: Team,
    route: '/',
  },
  {
    label: 'All Tools',
    component: Reports,
    route: '/',
  },
  {
    label: 'Settings',
    component: Settings,
    route: '/settings',
    icon: SettingsIcon,
    nestedRoutes: [
      {
        label: 'Admin Settings',
        component: AdminSettings,
        roles: [UserRoleNames.Admin, UserRoleNames.EngineeringAdmin],
        nestedRoutes: [
          {
            label: 'General Settings',
            component: GeneralSettings,
          },
          {
            label: 'Members',
            component: Members,
          },
          {
            label: 'Plans & Billings',
            component: PlansAndBillings,
          },
        ],
      },
      {
        label: 'Personal Settings',
        component: PersonalSettings,
        roles: [
          UserRoleNames.Admin,
          UserRoleNames.EngineeringAdmin,
          UserRoleNames.LeadingArchitect,
          UserRoleNames.Architect,
          UserRoleNames.LeadingStructuralEngineer,
          UserRoleNames.LeadingElectricalEngineer,
          UserRoleNames.StructuralEngineer,
          UserRoleNames.ElectricalEngineer,
        ],
      },
    ],
  },
]
